export enum variants {
    common = 'common',
    sidebar = 'sidebar',
}
